"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9555],{

/***/ 34579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ default_1; }
/* harmony export */ });
/* harmony import */ var _virtual_Clear_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19969);
/* harmony import */ var _babel_runtime_helpers_interopRequireDefault_esm_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66833);
/* harmony import */ var _utils_createSvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59695);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74512);





var _interopRequireDefault = _babel_runtime_helpers_interopRequireDefault_esm_js__WEBPACK_IMPORTED_MODULE_1__.i;
Object.defineProperty(_virtual_Clear_esm_js__WEBPACK_IMPORTED_MODULE_2__/* .__exports */ .m, "__esModule", {
  value: true
});
var default_1 = _virtual_Clear_esm_js__WEBPACK_IMPORTED_MODULE_2__/* .__exports["default"] */ .m["default"] = void 0;
var _createSvgIcon = _interopRequireDefault((0,_utils_createSvgIcon_esm_js__WEBPACK_IMPORTED_MODULE_3__/* .__require */ .s)());
var _jsxRuntime = react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__;
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');
default_1 = _virtual_Clear_esm_js__WEBPACK_IMPORTED_MODULE_2__/* .__exports["default"] */ .m["default"] = _default;




/***/ }),

/***/ 30280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Dialog$1; }
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.esm.js
var objectWithoutPropertiesLoose_esm = __webpack_require__(86804);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/extends.esm.js
var extends_esm = __webpack_require__(93335);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/clsx/dist/clsx.m.esm.js
var clsx_m_esm = __webpack_require__(88793);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useThemeProps.esm.js
var useThemeProps_esm = __webpack_require__(33164);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js
var generateUtilityClasses_esm = __webpack_require__(82637);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.esm.js
var generateUtilityClass_esm = __webpack_require__(90566);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Dialog/dialogClasses.esm.js



function getDialogUtilityClass(slot) {
  return (0,generateUtilityClass_esm/* default */.Z)('MuiDialog', slot);
}
const dialogClasses = (0,generateUtilityClasses_esm/* default */.Z)('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
var dialogClasses$1 = dialogClasses;



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Dialog/DialogContext.esm.js


const DialogContext = /*#__PURE__*/react.createContext({});
if (false) {}
var DialogContext$1 = DialogContext;



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useTheme.esm.js
var useTheme_esm = __webpack_require__(36713);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Backdrop/Backdrop.esm.js + 1 modules
var Backdrop_esm = __webpack_require__(18666);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Modal/Modal.esm.js + 4 modules
var Modal_esm = __webpack_require__(79520);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Paper/Paper.esm.js + 2 modules
var Paper_esm = __webpack_require__(41212);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/useId/useId.esm.js
var useId_esm = __webpack_require__(61237);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/composeClasses/composeClasses.esm.js
var composeClasses_esm = __webpack_require__(94723);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Fade/Fade.esm.js
var Fade_esm = __webpack_require__(93219);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/capitalize/capitalize.esm.js
var capitalize_esm = __webpack_require__(6573);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Dialog/Dialog.esm.js



















const _excluded = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
const DialogBackdrop = (0,styled_esm/* default */.ZP)(Backdrop_esm/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});
const useUtilityClasses = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${(0,capitalize_esm/* default */.Z)(scroll)}`],
    paper: ['paper', `paperScroll${(0,capitalize_esm/* default */.Z)(scroll)}`, `paperWidth${(0,capitalize_esm/* default */.Z)(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return (0,composeClasses_esm/* default */.Z)(slots, getDialogUtilityClass, classes);
};
const DialogRoot = (0,styled_esm/* default */.ZP)(Modal_esm/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer = (0,styled_esm/* default */.ZP)('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${(0,capitalize_esm/* default */.Z)(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => (0,extends_esm/* default */.Z)({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&:after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = (0,styled_esm/* default */.ZP)(Paper_esm/* default */.Z, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${(0,capitalize_esm/* default */.Z)(ownerState.scroll)}`], styles[`paperWidth${(0,capitalize_esm/* default */.Z)(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => (0,extends_esm/* default */.Z)({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11
}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));

/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */
const Dialog = /*#__PURE__*/react.forwardRef(function Dialog(inProps, ref) {
  const props = (0,useThemeProps_esm/* default */.Z)({
    props: inProps,
    name: 'MuiDialog'
  });
  const theme = (0,useTheme_esm/* default */.Z)();
  const defaultTransitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen
  };
  const {
      'aria-describedby': ariaDescribedby,
      'aria-labelledby': ariaLabelledbyProp,
      BackdropComponent,
      BackdropProps,
      children,
      className,
      disableEscapeKeyDown = false,
      fullScreen = false,
      fullWidth = false,
      maxWidth = 'sm',
      onBackdropClick,
      onClose,
      open,
      PaperComponent = Paper_esm/* default */.Z,
      PaperProps = {},
      scroll = 'paper',
      TransitionComponent = Fade_esm/* default */.Z,
      transitionDuration = defaultTransitionDuration,
      TransitionProps
    } = props,
    other = (0,objectWithoutPropertiesLoose_esm/* default */.Z)(props, _excluded);
  const ownerState = (0,extends_esm/* default */.Z)({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });
  const classes = useUtilityClasses(ownerState);
  const backdropClick = react.useRef();
  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };
  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }
    backdropClick.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };
  const ariaLabelledby = (0,useId_esm/* default */.Z)(ariaLabelledbyProp);
  const dialogContextValue = react.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogRoot, (0,extends_esm/* default */.Z)({
    className: (0,clsx_m_esm/* clsx */.W)(classes.root, className),
    closeAfterTransition: true,
    components: {
      Backdrop: DialogBackdrop
    },
    componentsProps: {
      backdrop: (0,extends_esm/* default */.Z)({
        transitionDuration,
        as: BackdropComponent
      }, BackdropProps)
    },
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionComponent, (0,extends_esm/* default */.Z)({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContainer, {
        className: (0,clsx_m_esm/* clsx */.W)(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogPaper, (0,extends_esm/* default */.Z)({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: (0,clsx_m_esm/* clsx */.W)(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContext$1.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
 false ? 0 : void 0;
var Dialog$1 = Dialog;




/***/ }),

/***/ 23732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DialogContent$1; }
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.esm.js
var objectWithoutPropertiesLoose_esm = __webpack_require__(86804);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/extends.esm.js
var extends_esm = __webpack_require__(93335);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/clsx/dist/clsx.m.esm.js
var clsx_m_esm = __webpack_require__(88793);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useThemeProps.esm.js
var useThemeProps_esm = __webpack_require__(33164);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.esm.js
var generateUtilityClass_esm = __webpack_require__(90566);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js
var generateUtilityClasses_esm = __webpack_require__(82637);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/DialogContent/dialogContentClasses.esm.js



function getDialogContentUtilityClass(slot) {
  return (0,generateUtilityClass_esm/* default */.Z)('MuiDialogContent', slot);
}
(0,generateUtilityClasses_esm/* default */.Z)('MuiDialogContent', ['root', 'dividers']);



;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/DialogTitle/dialogTitleClasses.esm.js



function getDialogTitleUtilityClass(slot) {
  return generateUtilityClass('MuiDialogTitle', slot);
}
const dialogTitleClasses = (0,generateUtilityClasses_esm/* default */.Z)('MuiDialogTitle', ['root']);
var dialogTitleClasses$1 = dialogTitleClasses;



// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/composeClasses/composeClasses.esm.js
var composeClasses_esm = __webpack_require__(94723);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/DialogContent/DialogContent.esm.js












const _excluded = ["className", "dividers"];
const useUtilityClasses = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return (0,composeClasses_esm/* default */.Z)(slots, getDialogContentUtilityClass, classes);
};
const DialogContentRoot = (0,styled_esm/* default */.ZP)('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => (0,extends_esm/* default */.Z)({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
  borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
} : {
  [`.${dialogTitleClasses$1.root} + &`]: {
    paddingTop: 0
  }
}));
const DialogContent = /*#__PURE__*/react.forwardRef(function DialogContent(inProps, ref) {
  const props = (0,useThemeProps_esm/* default */.Z)({
    props: inProps,
    name: 'MuiDialogContent'
  });
  const {
      className,
      dividers = false
    } = props,
    other = (0,objectWithoutPropertiesLoose_esm/* default */.Z)(props, _excluded);
  const ownerState = (0,extends_esm/* default */.Z)({}, props, {
    dividers
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(DialogContentRoot, (0,extends_esm/* default */.Z)({
    className: (0,clsx_m_esm/* clsx */.W)(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
 false ? 0 : void 0;
var DialogContent$1 = DialogContent;




/***/ }),

/***/ 53837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ InputAdornment$1; }
});

// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.esm.js
var objectWithoutPropertiesLoose_esm = __webpack_require__(86804);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@babel/runtime/helpers/esm/extends.esm.js
var extends_esm = __webpack_require__(93335);
// EXTERNAL MODULE: ../../../node_modules/react/index.js
var react = __webpack_require__(32735);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/clsx/dist/clsx.m.esm.js
var clsx_m_esm = __webpack_require__(88793);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/FormControl/FormControlContext.esm.js
var FormControlContext_esm = __webpack_require__(30995);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/FormControl/useFormControl.esm.js
var useFormControl_esm = __webpack_require__(38894);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/styled.esm.js
var styled_esm = __webpack_require__(99611);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClasses/generateUtilityClasses.esm.js
var generateUtilityClasses_esm = __webpack_require__(82637);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/generateUtilityClass/generateUtilityClass.esm.js
var generateUtilityClass_esm = __webpack_require__(90566);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/InputAdornment/inputAdornmentClasses.esm.js



function getInputAdornmentUtilityClass(slot) {
  return (0,generateUtilityClass_esm/* default */.Z)('MuiInputAdornment', slot);
}
const inputAdornmentClasses = (0,generateUtilityClasses_esm/* default */.Z)('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
var inputAdornmentClasses$1 = inputAdornmentClasses;



// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/styles/useThemeProps.esm.js
var useThemeProps_esm = __webpack_require__(33164);
// EXTERNAL MODULE: ../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(74512);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/Typography/Typography.esm.js + 1 modules
var Typography_esm = __webpack_require__(75320);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/composeClasses/composeClasses.esm.js
var composeClasses_esm = __webpack_require__(94723);
// EXTERNAL MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/utils/esm/capitalize/capitalize.esm.js
var capitalize_esm = __webpack_require__(6573);
;// CONCATENATED MODULE: ../../../packages/hermes-web-components/lib/node_modules/@mui/material/InputAdornment/InputAdornment.esm.js















var _span;
const _excluded = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];
const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[`position${(0,capitalize_esm/* default */.Z)(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
};
const useUtilityClasses = ownerState => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ['root', disablePointerEvents && 'disablePointerEvents', position && `position${(0,capitalize_esm/* default */.Z)(position)}`, variant, hiddenLabel && 'hiddenLabel', size && `size${(0,capitalize_esm/* default */.Z)(size)}`]
  };
  return (0,composeClasses_esm/* default */.Z)(slots, getInputAdornmentUtilityClass, classes);
};
const InputAdornmentRoot = (0,styled_esm/* default */.ZP)('div', {
  name: 'MuiInputAdornment',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => (0,extends_esm/* default */.Z)({
  display: 'flex',
  height: '0.01em',
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: '2em',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  color: (theme.vars || theme).palette.action.active
}, ownerState.variant === 'filled' && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses$1.positionStart}&:not(.${inputAdornmentClasses$1.hiddenLabel})`]: {
    marginTop: 16
  }
}, ownerState.position === 'start' && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, ownerState.position === 'end' && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, ownerState.disablePointerEvents === true && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: 'none'
}));
const InputAdornment = /*#__PURE__*/react.forwardRef(function InputAdornment(inProps, ref) {
  const props = (0,useThemeProps_esm/* default */.Z)({
    props: inProps,
    name: 'MuiInputAdornment'
  });
  const {
      children,
      className,
      component = 'div',
      disablePointerEvents = false,
      disableTypography = false,
      position,
      variant: variantProp
    } = props,
    other = (0,objectWithoutPropertiesLoose_esm/* default */.Z)(props, _excluded);
  const muiFormControl = (0,useFormControl_esm/* default */.Z)() || {};
  let variant = variantProp;
  if (variantProp && muiFormControl.variant) {
    if (false) {}
  }
  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }
  const ownerState = (0,extends_esm/* default */.Z)({}, props, {
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position,
    variant
  });
  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormControlContext_esm/* default.Provider */.Z.Provider, {
    value: null,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornmentRoot, (0,extends_esm/* default */.Z)({
      as: component,
      ownerState: ownerState,
      className: (0,clsx_m_esm/* clsx */.W)(classes.root, className),
      ref: ref
    }, other, {
      children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/(0,jsx_runtime.jsx)(Typography_esm/* default */.Z, {
        color: "text.secondary",
        children: children
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */_span || (_span = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "notranslate",
          children: "\u200B"
        })) : null, children]
      })
    }))
  });
});
 false ? 0 : void 0;
var InputAdornment$1 = InputAdornment;




/***/ })

}]);